/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useMediaQuery } from "@mui/material";
import OrganizationStructure from "../../../../components/common/OrganizationStructure/OrganizationStructure";
import OrganizationStructureForMobileView from "../../../../components/common/OrganizationStructure/OrganizationStructureForMobileView";
import { selectUserProfile } from "../../../../redux/selectors/user";
import { isEmptyObj } from "../../../../utils/helper";
import styles from "./Structure.styles";

function StructureFilter({
  values,
  handleChange,
  errors,
  setFieldValue,
  disabledOSKeys,
  required,
}) {
  const [shouldFetchOtherOS, setShouldFetchOtherOS] = useState(false);
  const userData = useSelector(selectUserProfile);
  const isMobile = useMediaQuery("(max-width: 768px)");

  const preselectOSKeys = () => {
    if (disabledOSKeys?.length && !isEmptyObj(userData)) {
      disabledOSKeys.forEach((key) => {
        if (userData[key]) {
          setFieldValue(key, userData[key]);
        }
      });
      setShouldFetchOtherOS(true);
    }
  };

  // SSR
  useEffect(() => {
    preselectOSKeys();
  }, [disabledOSKeys, userData]);

  return isMobile ? (
    <OrganizationStructureForMobileView
      values={values}
      errors={errors}
      showZoneLocator={false}
      showTitle={false}
      showBlock
      required={required}
      handleChange={handleChange}
      setFieldValue={setFieldValue}
      shouldFetchOtherOS={shouldFetchOtherOS}
      containerStyle={styles.container}
      disabledOSKeys={disabledOSKeys}
    />
  ) : (
    <OrganizationStructure
      values={values}
      errors={errors}
      showZoneLocator={false}
      showTitle={false}
      showBlock
      required={required}
      handleChange={handleChange}
      setFieldValue={setFieldValue}
      shouldFetchOtherOS={shouldFetchOtherOS}
      containerStyle={styles.container}
      disabledOSKeys={disabledOSKeys}
    />
  );
}

export default StructureFilter;
